<template>
  <div class="operation-item">
        <a-col class="leftStyle product-flg" :span="10" :offset="0">
          <div
            :class="typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(WAREHOUSETYPE.PLAN_FORMAL_ORDER)"
          >
          <img v-if="typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">仓配一体出库单</p>
            <p class="skuStyle">
              上传仓配出库计划单生成WMS出库订单
            </p>
            <div 
              v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配出库计划单`:`批量导入下单-下载模板-仓配出库计划单`}" 
              class="batchBtnStyle"
               @click="downloadExcelWareHouseTransport('仓配出库计划单', 'PLAN_ORDER')" 
            >
              <img src="@/assets/img/icon/xlsx.png" />
              仓配出库计划单
              <img class="icon_load" :src="typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
  </div>
</template>

<script>
import downloadField from '@/assets/img/icon/download_field.png'
import downloads from '@/assets/img/icon/download.png'
import { WAREHOUSETYPE,TEMPLATEURL } from '../multipleConst'

export default {
  name: 'WarehouseMultiple',
  components: {
  },
  props: {
    typeIndex: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      TEMPLATEURL,
      WAREHOUSETYPE,
      downloadField,
      downloads,
      type: WAREHOUSETYPE.PLAN_FORMAL_ORDER,
    }
  },
  watch: {
    typeIndex() {
      this.changeType(WAREHOUSETYPE.PLAN_FORMAL_ORDER)
    }
  },
  methods: {
    downloadExcelWareHouseTransport(item, type) {
      this.$emit('downloadExcelWareHouseTransport', item, type)
    },
    editTypeIndex(index) {
      this.$emit('editTypeIndex', index)
    },
    downloadTemplate(item, type, isTransport) {
      this.$emit('downloadTemplate', item, type, isTransport)
    },
    changeType(type) {
      this.type = type;
      this.$emit('changeWareHouseType', type)
    }
  }
}
</script>

<style lang="less" scoped>
.radioBox {
  .justify-between {
    .batchBtn {
      background: #F2FBF8;
      border-radius: 4px;
      padding: 10px;
      color: #06B880;
      border: 1px dashed #ebe8e8;
      flex: 1;
      display: flex;
      justify-content: space-between;
      &:last-of-type {
        margin-left: 10px;
      }
      &:hover {
        border: 1px dashed #06B880;
      }
    }
  }
  &.radioBoxActive {
    .justify-between {
      .batchBtn {
        &.isActive {
          border: 1px dashed #06B880;
        }
      }
    }
  }
}
</style>
